import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import equipmentService from "../../services/EquipmentService";
import { Equipment } from "../../interfaces";

interface EquipmentState {
  equipments: Equipment[];
  error?: string | null;
  loading: boolean;
}

const initialState: EquipmentState = {
  equipments: [],
  error: null,
  loading: false,
};

export const fetchEquipments = createAsyncThunk(
  "equipments/fetchEquipments",
  async () => {
    try {
      const response = await equipmentService.getAll();
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const addEquipment = createAsyncThunk(
  "equipments/addEquipment",
  async (data: any) => {
    try {
      const response = await equipmentService.post(data);
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const updateEquipment = createAsyncThunk(
  "equipments/updateEquipment",
  async (data: any) => {
    try {
      const response = await equipmentService.put(data.id, data);
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const removeEquipment = createAsyncThunk(
  "equipments/removeEquipment",
  async (id: number) => {
    try {
      const response = await equipmentService.remove(id);
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

const equipmentSlice = createSlice({
  name: "equipments",
  initialState,
  reducers: {
    setEquipments: (state, action) => {
      state.equipments = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEquipments.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEquipments.fulfilled, (state, action) => {
        state.loading = false;
        state.equipments = action.payload;
      })
      .addCase(fetchEquipments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addEquipment.pending, (state) => {
        state.loading = true;
      })
      .addCase(addEquipment.fulfilled, (state, action) => {
        state.loading = false;
        state.equipments.push(action.payload);
      })
      .addCase(addEquipment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateEquipment.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateEquipment.fulfilled, (state, action) => {
        state.loading = false;
        state.equipments = state.equipments.map((equipment) =>
          equipment.id === action.payload.id ? action.payload : equipment
        );
      })
      .addCase(updateEquipment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(removeEquipment.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeEquipment.fulfilled, (state, action) => {
        state.loading = false;
        state.equipments = state.equipments.filter(
          (equipment) => equipment.id !== action.payload.id
        );
      })
      .addCase(removeEquipment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

const { reducer } = equipmentSlice;
export default reducer;
